import ZApiService from './ZApiService';
import { IImage } from '@/common/interfaces/image.interface';

export default class PartnerService {
  private zApiService: ZApiService;

  constructor(zApiService: ZApiService) {
    this.zApiService = zApiService;
  }

  public async postPartnerImage(image: IImage): Promise<IImage> {
    return {
      imageUrl: await this.zApiService.postPartnerImage(image),
    };
  }
}
